function httpsUrl(value: string | null): URL | null {
  if (!value || /[\u0000-\u0020\\]/.test(value)) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password && !url.port
      ? url
      : null;
  } catch {
    return null;
  }
}

/** Only original post paths; discard tracking/query data and redirect endpoints. */
export function instagramPermalink(value: string | null): string | null {
  const url = httpsUrl(value);
  if (!url || !['instagram.com', 'www.instagram.com'].includes(url.hostname)) return null;
  if (!/^\/(?:p|reel|tv)\/[A-Za-z0-9_-]{1,128}\/?$/.test(url.pathname)) return null;
  url.search = '';
  url.hash = '';
  return url.href;
}

/**
 * Defense for provider URLs supplied by the public API, never a remote-fetch proxy.
 * The API must supply current approved media and thumbnails; this cannot validate
 * a provider's later HTTP redirects or decide whether a post may be published.
 */
export function instagramPreviewUrl(value: string | null): string | null {
  const url = httpsUrl(value);
  if (!url) return null;
  const cdn = ['fbcdn.net', 'cdninstagram.com'].some(
    (host) => url.hostname === host || url.hostname.endsWith(`.${host}`),
  );
  const instagram = ['instagram.com', 'www.instagram.com'].includes(url.hostname);
  if (!cdn && !instagram) return null;
  if (/^\/(?:l\.php|redirect|url|accounts|oauth)(?:\/|$)/i.test(url.pathname)) return null;
  return url.href;
}
